// extracted by mini-css-extract-plugin
export var cardSelected = "_hh-2";
export var image = "_hh-1";
export var table = "_hh-0";